import {Component, Injector, OnInit} from '@angular/core';
import {BaseComponent} from '../../base.component';
import {FilterUtil} from '../../../util/filter.util';
import {ListResponse} from '../../../network/service/list.response';
import {SnackBarUtil} from '../../../util/snack.bar.util';
import {DataResponse} from '../../../network/service/data.response';
import {VerifyOptions} from '../../dialog/verify/options/verify.options';
import {VerifyComponent} from '../../dialog/verify/verify.component';
import {RequestType} from '../../../enums/request.type';
import {RouteUtil} from '../../../util/route.util';

@Component({
  selector: 'app-services',
  standalone: false,
  templateUrl: './services.component.html',
  styleUrl: './services.component.scss'
})
export class ServicesComponent extends BaseComponent implements OnInit {
  displayedColumns = ['Update', 'Delete', 'Title', 'Rate', 'ViewCount'];
  displayDataSources = ['edit', 'delete', 'Title', 'Rate', 'ViewCount'];
  displayColumnTypes = ['event', 'event', 'string', 'number', 'number'];
  displayEndPoint = ['', '', '', '', ''];
  services: any = [];
  allFilters = FilterUtil.DeliveryMethodsFilters;
  filters: any = {};

  constructor(injector: Injector) {
    super(injector);
  }

  override ngOnInit() {
    super.ngOnInit();
  }

  override loadOnline() {
    super.loadOnline();
    this.serviceApi.getServices(this.tableProperties.offset, this.tableProperties.limit, 'ServicePrice', RequestType.PAGINATE, undefined, {
      Filter: this.filters,
    }).subscribe((res: ListResponse<any>) => {
      if (res.success) {
        this.services = res.data;
        this.tableProperties.pageLength = res.count;
        this.setListeners();
      } else {
        SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
      }
    });
  }

  override setListeners() {
    super.setListeners();
    if (this.services) {
      for (let i = 0; i < this.services.length; i++) {
        this.services[i].edit = (index: number) => {
          this.onUpdateClicked(index);
        };
        this.services[i].delete = (index: number) => {
          this.onDeleteClicked(index);
        };
      }
    }
  }

  override pageChanged(event: any) {
    super.pageChanged(event);
    this.tableProperties.offset = (event.pageIndex);
    this.loadOnline();
  }

  override onSortChanged(event: any) {
    super.onSortChanged(event);
    this.loadOnline();
  }

  onFiltersChanged(filters: any) {
    this.filters = filters;
    this.tableProperties.offset = 0;
    this.loadOnline();
  }

  onCreateClicked() {
    this.router.navigate([RouteUtil.DASHBOARD_MODULE, RouteUtil.ADD_OR_UPDATE_SERVICE_COMPONENT]).then();
  }

  onUpdateClicked(index: number) {
    this.router.navigate([RouteUtil.DASHBOARD_MODULE, RouteUtil.ADD_OR_UPDATE_SERVICE_COMPONENT, {
      ServiceId: this.services[index].ServiceId
    }]).then();
  }

  onDeleteClicked(index: number) {
    let verifyOptions = new VerifyOptions();
    verifyOptions.message = 'آیا از حذف درخواست خود مطمئن هستید؟';
    let verifyComponent = this.matDialog.open(VerifyComponent);
    verifyOptions.onNoClicked = () => {
      verifyComponent.close();
    };
    verifyOptions.onYesClicked = () => {
      this.serviceApi.deleteServices(this.services[index].ServiceId).subscribe((res: DataResponse<any>) => {
        if (res.success) {
          verifyComponent.close();
          this.loadOnline();
        } else {
          SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
        }
      });
    };
    verifyComponent.componentInstance.verifyOptions = verifyOptions;
  }
}
